export const SERVICE_REQUEST_STATUS = {
  ALL: 'all',
  PENDING: 'P',
  VERIFIED: 'V',
  ACCEPTED: 'A',
  REJECTED: 'R'
} as const;

export type ServiceRequestStatus = (typeof SERVICE_REQUEST_STATUS)[keyof typeof SERVICE_REQUEST_STATUS];

export const SERVICE_REQUEST_STATUS_LABELS = {
  [SERVICE_REQUEST_STATUS.ALL]: 'All',
  [SERVICE_REQUEST_STATUS.PENDING]: 'Pending',
  [SERVICE_REQUEST_STATUS.VERIFIED]: 'Verified',
  [SERVICE_REQUEST_STATUS.ACCEPTED]: 'Accepted',
  [SERVICE_REQUEST_STATUS.REJECTED]: 'Rejected'
} as const;

export type ServiceRequestStatusLabels =
  (typeof SERVICE_REQUEST_STATUS_LABELS)[keyof typeof SERVICE_REQUEST_STATUS_LABELS];

export const SERVICE_REQUEST_REJECT_REASONS = {
  ALTERNATE_TRANSPORT: 'A',
  NO_LONGER_NEEDED: 'L',
  CLUSTER_UNABLE_TO_SUPPORT: 'S',
  INFORMATION_ERROR: 'E',
  OTHER: 'O'
} as const;

export type ServiceRequestRejectReason =
  (typeof SERVICE_REQUEST_REJECT_REASONS)[keyof typeof SERVICE_REQUEST_REJECT_REASONS];

export const SERVICE_REQUEST_REJECT_REASON_LABELS = {
  [SERVICE_REQUEST_REJECT_REASONS.ALTERNATE_TRANSPORT]: 'Alternate transport arranged',
  [SERVICE_REQUEST_REJECT_REASONS.NO_LONGER_NEEDED]: 'No longer needed',
  [SERVICE_REQUEST_REJECT_REASONS.CLUSTER_UNABLE_TO_SUPPORT]: 'Cluster unable to support',
  [SERVICE_REQUEST_REJECT_REASONS.INFORMATION_ERROR]: 'Information / dispatch error',
  [SERVICE_REQUEST_REJECT_REASONS.OTHER]: 'Other'
} as const;
